import { ShippingDataForRetailerStoreInterfaceSnapshotOut } from '../state-manager/ShippingDataForRetailer'

export const ShippingDataForRetailerStoreMock: ShippingDataForRetailerStoreInterfaceSnapshotOut = {
  firstname: '',
  lastname: '',
  phone: ''
}

export default ShippingDataForRetailerStoreMock
